/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useSettings } from '@/data/Settings';
import { formatPrice } from '@/utils/formatPrice';
import { useMemo } from 'react';

type PriceDisplayProps = {
	min: number;
	max?: number;
	currency?: string;
	locale?: string;
	isElectronico?: boolean;
};

/**
 * Formatted Price or Price Range Display component
 * displays a price or price range between min price to max price that is formatted to the currency and locale
 * @param props
 */
export const PriceDisplay: React.FC<PriceDisplayProps> = ({
	min,
	max,
	currency: _currency,
	locale: _locale,
	isElectronico,
}) => {
	const { settings } = useSettings();

	const currency = useMemo(
		() => _currency ?? settings?.defaultCurrency,
		[_currency, settings?.defaultCurrency]
	);
	const locale = 'es-MX';

	return (
		<>
			{max === undefined ? (
				<>{formatPrice(locale, currency, min, isElectronico)}</>
			) : (
				<>{`${formatPrice(locale, currency, min, isElectronico)} - ${formatPrice(
					locale,
					currency,
					max,
					isElectronico
				)}`}</>
			)}
		</>
	);
};
